import { helpers } from "vuelidate/lib/validators";

export function fileSize (param) {
    return helpers.withParams(
        { type: 'fileSize', value: param},
        (file) => {
            return !helpers.req(file) || file.size <= param;
        }
    );
}
export function fileType (param){
    param = Array.isArray(param) ? param : [param];
    return helpers.withParams(
        { type: 'fileType', value: param },
        (file) => {
            return !helpers.req(file) || param.findIndex((type)=>type == file.type) != -1;
        }
    )
}

export function equalTo (param){
    return helpers.withParams(
        { type: 'equalTo', value: param },
        (input) => {
            return !helpers.req(input) || param == input;
        }
    )
}
